import * as nxlProtocol from 'service/nxl-protocol';
import { AccountApi } from './axios-api';

const {
    settings,
    application,
    electron: { openExternal },
    location,
} = window;

// for carrying login session to external browser
export const openExternalUrl = async (url: string, ssoRequired: boolean = false) => {
    const tempURL = new URL(url);
    tempURL.searchParams.append('utm_source', window.location.pathname);
    tempURL.searchParams.append('utm_medium', 'nxl');
    url = tempURL.href;

    if (!ssoRequired) {
        openExternal(url);
        return;
    }

    try {
        const { authenticationCode }: any = await AccountApi.post('/login/code', {
            deviceId: application.params.device_id,
        });
        const middlewareUrl = `${
            settings.hosts.accounts
        }/account/login/sso?authentication_code=${authenticationCode}&redirect_uri=${encodeURIComponent(url)}`;
        openExternal(middlewareUrl);
    } catch (e) {
        openExternal(url);
    }
};

window.openExternal = openExternalUrl; // replace for account web

export const openUrlHandler = (url: string) => {
    const parser = document.createElement('a');
    parser.href = url;
    switch (parser.protocol) {
        case 'nxl:':
            nxlProtocol.exec(url);
            break;
        case 'http:':
        case 'https:':
            openExternalUrl(url, false); // all links from launcher
            break;
    }
};

const supportExternalLinks = (event: MouseEvent) => {
    function crawlDom(element: any, depth: number) {
        if (element.localName === 'a') {
            // ctrl+left click or not left click (middle/right mouse click)
            if (event.ctrlKey || event.which !== 1) {
                event.preventDefault();
                return;
            }
            if (element.href && (location.host !== element.host || element.target)) {
                event.preventDefault();
                openUrlHandler(element.href);
            }
            return;
        }

        if (element.parentElement && depth > 0) {
            crawlDom(element.parentElement, depth - 1);
        }
    }
    crawlDom(event.target, 4);
};

document.body.addEventListener('click', supportExternalLinks);
document.body.addEventListener('auxclick', supportExternalLinks); // middle mouse button
